import { Slider, Switch } from "@mui/material";

import "../css/Reader.css";

export const FONT_SIZE_MIN = 1;
export const FONT_SIZE_MAX = 2;
const FONT_SIZE_STEP = 0.1;

type Props = {
  isDys: boolean;
  fontSize: number;
  onDysChange: (isDys: boolean) => void;
  onFontSizeChange: (fontSize: number) => void;
};

const clampFontSize = (value: number) =>
  Math.min(FONT_SIZE_MAX, Math.max(FONT_SIZE_MIN, Math.round(value * 10) / 10));

const ReaderSettings = (props: Props) => {
  const { isDys, fontSize, onDysChange, onFontSizeChange } = props;

  return (
    <section className="rd-section" aria-labelledby="rd-settings-title">
      <h2 id="rd-settings-title" className="rd-section__title">
        Confort de lecture
      </h2>

      <div className="rd-setting">
        <div className="rd-setting__row">
          <label htmlFor="rd-dys-switch" className="rd-setting__label">
            Police adaptée DYS
            <span className="rd-setting__hint">Plus facile à lire pour les lecteurs dyslexiques</span>
          </label>
          <Switch
            id="rd-dys-switch"
            checked={isDys}
            onChange={(_event, checked) => onDysChange(checked)}
            sx={{
              "& .MuiSwitch-switchBase.Mui-checked": { color: "#FECF03" },
              "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "#FECF03" },
              "& .MuiSwitch-track": { backgroundColor: "rgba(255, 255, 255, 0.4)" },
            }}
          />
        </div>
      </div>

      <div className="rd-setting">
        <div className="rd-setting__row">
          <span id="rd-font-size-label" className="rd-setting__label">
            Taille du texte
          </span>
          <span className="rd-setting__value">{Math.round(fontSize * 100)} %</span>
        </div>
        <div className="rd-font-size">
          <button
            type="button"
            className="rd-font-size__btn"
            style={{ fontSize: 13 }}
            onClick={() => onFontSizeChange(clampFontSize(fontSize - FONT_SIZE_STEP))}
            disabled={fontSize <= FONT_SIZE_MIN}
            aria-label="Réduire la taille du texte"
          >
            A
          </button>
          <Slider
            min={FONT_SIZE_MIN}
            max={FONT_SIZE_MAX}
            step={FONT_SIZE_STEP}
            value={fontSize}
            onChange={(_event, value) => onFontSizeChange(clampFontSize(Number(value)))}
            aria-labelledby="rd-font-size-label"
            getAriaValueText={(value) => `${Math.round(value * 100)} %`}
            sx={{ color: "#FECF03" }}
          />
          <button
            type="button"
            className="rd-font-size__btn"
            style={{ fontSize: 20 }}
            onClick={() => onFontSizeChange(clampFontSize(fontSize + FONT_SIZE_STEP))}
            disabled={fontSize >= FONT_SIZE_MAX}
            aria-label="Augmenter la taille du texte"
          >
            A
          </button>
        </div>
        <p
          className="rd-preview"
          style={{
            fontFamily: isDys ? "OpenDyslexic-Regular" : "Poppins-Regular",
            fontSize: 14 * fontSize,
          }}
          aria-hidden="true"
        >
          Il était une fois…
        </p>
      </div>
    </section>
  );
};

export default ReaderSettings;
